import { withInstall } from '@ll-plus/utils'

import Gantt from './src/gantt.vue'

export const LlGantt = withInstall(Gantt)
export default LlGantt
export * from './src/gantt'

declare module 'vue' {
  export interface GlobalComponents {
    LlGantt: typeof Gantt
  }
}
